module.exports = __webpack_public_path__ + "resources/img/img-zenius-ems-02-en.9fb1e1a3c347bd3c64ac9b3bc24262b2.png";